import { PayloadAction } from '@reduxjs/toolkit';
import type { ViewAlphaQuoteResponse } from '@snap-types/actions/view-alpha-quote';

import { WritableAutoConfiguratorState } from '../slice';
import { revalidateLineQuantities } from '../validation/revalidate-line-quantities';
import { buildImportedLineState } from './build-imported-line-state';

type SetQuoteLinesPayload = {
  alphaQuote: ViewAlphaQuoteResponse;
};

export function setQuoteLines(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<SetQuoteLinesPayload>,
) {
  const { quoteLines, staticData } = action.payload.alphaQuote;

  state.staticData = staticData;
  state.pendingRecalculationCount = 0;
  state.pendingCalculationRequestIdByLineItemUuid = {};
  state.calculationErrorsByLineItemUuid = {};
  state.lastSaveDateTime = null;
  state.lineItemUuids = [];
  state.lineItems = {};
  state.quantityBreaks = {};

  for (const [index, quoteLine] of quoteLines.entries()) {
    const { lineItem, quantityBreaks } = buildImportedLineState(
      quoteLine,
      index + 1,
    );

    state.lineItemUuids.push(lineItem.uuid);
    state.lineItems[lineItem.uuid] = lineItem;

    for (const quantityBreak of quantityBreaks) {
      state.quantityBreaks[quantityBreak.uuid] = quantityBreak;
    }

    revalidateLineQuantities(state, lineItem.uuid);
  }
}
